// extracted by mini-css-extract-plugin
export var inset = "clamp-module--inset--RL8si";
export var root = "clamp-module--root--XzsR+";